import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=0bdbbba8"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=0bdbbba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports